import { useState } from "react";
import { ArrowRight, Check, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { subscribeNewsletter, apiError } from "@/lib/api";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [human, setHuman] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!human) return toast.error("Confirma que eres humano pulsando «Soy humano».");
    setLoading(true);
    try {
      const res = await subscribeNewsletter(email);
      toast.success(res.message || "Suscripción confirmada.");
      setEmail(""); setHuman(false);
    } catch (e) { toast.error(apiError(e)); }
    finally { setLoading(false); }
  };

  return (
    <section className="border-t border-[#0f2544]/12" data-testid="newsletter-section">
      <div className="max-w-[1500px] mx-auto px-4 sm:px-6 lg:px-10 py-20 md:py-28 grid md:grid-cols-2 gap-10 md:gap-16 items-center">
        <div>
          <p className="hv-overline">Boletín</p>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold tracking-tight mt-4 leading-[0.98]">Mantente cerca<br />de Harvest</h2>
        </div>
        <form onSubmit={submit} data-testid="newsletter-form">
          <div className="flex items-center border-b-2 border-[#0f2544] pb-2">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@email.com"
              className="flex-1 bg-transparent text-lg outline-none placeholder:text-[#8a8a83]" data-testid="newsletter-email" />
            <button type="submit" disabled={loading} className="p-2 text-[#0f2544] hover:text-[#1f44e0] transition-colors disabled:opacity-40" data-testid="newsletter-submit" aria-label="Suscribirme">
              <ArrowRight size={22} />
            </button>
          </div>
          <button
            type="button"
            onClick={() => setHuman((v) => !v)}
            aria-pressed={human}
            className={`mt-4 inline-flex items-center gap-2 px-4 py-2.5 text-xs font-semibold tracking-[0.12em] uppercase border transition-colors ${
              human
                ? "bg-[#0f2544] text-white border-[#0f2544]"
                : "bg-transparent text-[#0f2544] border-[#0f2544]/40 hover:border-[#0f2544]"
            }`}
            data-testid="newsletter-human"
          >
            {human ? <Check size={15} /> : <ShieldCheck size={15} />}
            {human ? "Verificado · Soy humano" : "Soy humano"}
          </button>
        </form>
      </div>
    </section>
  );
}
